import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useLocationState = () => {
    const { state } = useLocation();
    return useMemo(() => state, [state]);
}